
/*import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/
export default {
  name: "RecapSignOk",
   data () {
    return {
      contactEmail:null,
      loading:false

    }
  },
  mounted: function () {
    this.contactEmail = this.$globalService.getSessionSouscription().contactEmail
  },
  methods: {
    prendreRendezvous: function() {
      if(this.$globalService.getSessionSouscription().active_rdv == true && this.$globalService.getSessionSouscription().serviceChoisi 
      && this.checkDateCommercialisation(this.$globalService.getSessionSouscription().serviceChoisi)  ){
        this.$router.push({name: 'RdvCreneaux'});   // désactivation de la réservation des rdv le 06/01/2021 pour vérification
      }else
        this.$router.push({name: 'Final'});
    },
   
    checkDateCommercialisation: function(service) {
      if(service.type=='ftth' && service.date_commercialisation) {
        var d= Date.parse(service.date_commercialisation);
        var e = new Date();
        return (d > e ? false : true);
      } else {
        return false;
      }
    }
  }
}